// Admin Route - Protege rutas exclusivas de administradores
// [H-T002] Verificacion redundante de user y emailVerified como defensa en profundidad.
// Aunque AdminRoute esta anidado dentro de ProtectedRoute en App.tsx,
// verificamos aqui tambien para prevenir problemas si se reorganizan las rutas.
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import { Loading } from '../ui/loading';

interface AdminRouteProps {
  children: React.ReactNode;
}

export function AdminRoute({ children }: AdminRouteProps) {
  const { user, userRole, initialized, emailVerified } = useAuthStore();

  if (!initialized) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loading size="lg" />
      </div>
    );
  }

  // [H-T002] Defensa en profundidad: verificar autenticacion y email
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!emailVerified) {
    return <Navigate to="/verify-email" replace />;
  }

  if (userRole !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
